
export enum ProductType {
    Ticket = "Ticket",
    PrepaidCard = "PrepaidCard",
    MembershipCard = "MembershipCard",
    Donation = "Donation"
}

export enum ProductTypeEnum {
    Ticket = 1,
    PrepaidCard = 2,
    MembershipCard = 3,
    Donation = 4
}

export enum CurrencyCode {
    CAD = "CAD",
}

export enum InSaleStatus {
    INSALE = 'INSALE',
    PAST = 'PAST',
    HIDEONINTERNET = 'HIDEONINTERNET',
    SALENOTEND = 'SALENOTEND',
    SALEFINISH = 'SALEFINISH',
    SALENOTSTARTEDYET = 'SALENOTSTARTEDYET'
}

export enum SeatsAvailability {
    SeatsAvailabilityNormal = "SEATS_AVAILABILITY_NORMAL",
    SeatsAvailabilitySoldOut = "SEATS_AVAILABILITY_SOLDOUT",
    SeatsAvailabilityFewSeats = "SEATS_AVAILABILITY_FEW_SEATS",
}